import { render, staticRenderFns } from "./validateOTP.vue?vue&type=template&id=1e3b36ef&scoped=true&"
import script from "./validateOTP.vue?vue&type=script&lang=js&"
export * from "./validateOTP.vue?vue&type=script&lang=js&"
import style0 from "./validateOTP.vue?vue&type=style&index=0&id=1e3b36ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b36ef",
  null
  
)

export default component.exports